import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';
import {
  DEFAULT_IANA_TIME_ZONE,
  getIanaTimeZones,
  normalizeTimeZone,
} from '../../utils/timeZoneOptions';

type Props = {
  value?: string | null;
  onChange: (timeZone: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
};

const TimeZoneAutocomplete = ({
  value,
  onChange,
  label = 'Időzóna',
  disabled = false,
  required = false,
  error = false,
  helperText,
}: Props) => {
  const options = useMemo(() => getIanaTimeZones(), []);
  const selected = normalizeTimeZone(value);

  return (
    <Autocomplete
      options={options}
      value={options.includes(selected) ? selected : selected || DEFAULT_IANA_TIME_ZONE}
      disabled={disabled}
      onChange={(_e, next) => onChange(next || DEFAULT_IANA_TIME_ZONE)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText ?? 'IANA időzóna (pl. Europe/Budapest)'}
          fullWidth
        />
      )}
    />
  );
};

export default TimeZoneAutocomplete;
